import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import VehicleCheckTicker from './VehicleCheckTicker';
import QuestionMark from './QuestionMark';
import tokens from '../theme/tokens';

// 물품 목록 아래 진입 카드 — 큰 물음표 말풍선 아이콘 + 「제 물품이 어떤 배송에 적합할까요?」 / 「퀴노스 AI를 한번 사용해보세요!」
// 아래 띠에는 고객 질문이 전광판처럼 한 줄씩 돌아간다(VehicleCheckTicker). 카드 어디를 눌러도 조회 모달이 열린다
const useStyles = makeStyles(() => ({
  root: {
    display: 'block',
    width: 440,
    maxWidth: '100%',
    marginTop: 24,
    borderRadius: 16,
    border: `1px solid ${tokens.primaryLine}`,
    backgroundColor: tokens.surface,
    boxShadow: '0 6px 16px 0 rgba(247, 124, 64, 0.10)',
    overflow: 'hidden',
    textAlign: 'left',
    transition: 'border-color .15s, box-shadow .15s',
    '&:hover': { borderColor: tokens.primary, boxShadow: tokens.cardShadow },
  },
  head: { display: 'flex', alignItems: 'center', padding: '14px 16px 12px' },
  mark: { flex: 'none', width: 56, height: 56, marginRight: 14, filter: 'drop-shadow(0 4px 8px rgba(247, 124, 64, 0.28))' },
  texts: { flex: '1 1 auto', minWidth: 0 },
  title: { fontSize: 16, fontWeight: 700, letterSpacing: -0.7, lineHeight: 1.3, color: tokens.ink, wordBreak: 'keep-all' },
  sub: { marginTop: 3, fontSize: 13, fontWeight: 700, letterSpacing: -0.5, color: tokens.primaryDark },
  chevron: { flex: 'none', width: 18, height: 18, marginLeft: 8, color: tokens.muted },
  dense: {
    width: '100%',
    marginTop: 20,
    '& $head': { padding: '12px 14px 10px' },
    '& $mark': { width: 46, height: 46, marginRight: 12 },
    '& $title': { fontSize: 15 },
    '& $sub': { fontSize: 12 },
  },
}));

function VehicleCheckEntry({ onClick, dense = false, className }) {
  const cs = useStyles();
  return (
    <ButtonBase className={clsx(cs.root, dense && cs.dense, className)} onClick={onClick} focusRipple={false}>
      <div className={cs.head}>
        <QuestionMark className={cs.mark} />
        <div className={cs.texts}>
          <div className={cs.title}>제 물품이 어떤 배송에 적합할까요?</div>
          <div className={cs.sub}>퀴노스 AI를 한번 사용해보세요!</div>
        </div>
        <svg className={cs.chevron} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
      </div>
      <VehicleCheckTicker dense={dense} />
    </ButtonBase>
  );
}

export default VehicleCheckEntry;
